export default "__VITE_ASSET__bd1617ac__"